import { render, staticRenderFns } from "./hehuaCultureDetail.vue?vue&type=template&id=302b004a&scoped=true&"
import script from "./hehuaCultureDetail.vue?vue&type=script&lang=js&"
export * from "./hehuaCultureDetail.vue?vue&type=script&lang=js&"
import style0 from "./hehuaCultureDetail.vue?vue&type=style&index=0&id=302b004a&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302b004a",
  null
  
)

export default component.exports